import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import extractText from 'flarum/common/utils/extractText';
import getBadgeSvg from '../../common/verified/getBadgeSvg';
/**
 * Selo de "loja verificada" (verificacao da LOJA pelo admin, distinta da conta).
 * Usa o MESMO icone padrao da extensao verified (getBadgeSvg) e a mesma estrutura
 * de popover (classes VerifiedPopover-*), herdando a cor padrao do Flarum
 * (--primary-color). O conteudo do popover e proprio da loja. Posicionamento
 * (canto do avatar, popover pra baixo) vem do CSS .MpStoreVerified.
 */
export default class StoreVerifiedBadge extends Component {
  view() {
    const title = extractText(app.translator.trans('ramon-marketplace.forum.seller_profile.verified_title'));
    const desc = app.translator.trans('ramon-marketplace.forum.seller_profile.verified_desc');

    // SVG do selo padrao da verified, ja sanitizado (allowlist DOMParser).
    // Dois vnodes distintos (badge + header do popover) precisam de trust separado.
    const svg = getBadgeSvg(null);
    const badge = m.trust(svg); // nosemgrep: flarum-v2-m-trust
    const headerIcon = m.trust(svg); // nosemgrep: flarum-v2-m-trust

    return m("span", {
      className: "VerifiedPopover-anchor MpStoreVerified",
      tabIndex: 0,
      "aria-label": title
    }, m("span", {
      className: "VerifiedBadge VerifiedBadge--inAnchor",
      role: "img",
      "aria-label": title
    }, badge), m("span", {
      className: "VerifiedPopover",
      role: "tooltip"
    }, m("span", {
      className: "VerifiedPopover-arrow",
      "aria-hidden": "true"
    }), m("span", {
      className: "VerifiedPopover-header"
    }, m("span", {
      className: "VerifiedPopover-headerIcon"
    }, headerIcon), m("span", {
      className: "VerifiedPopover-headerText"
    }, desc))));
  }
}
flarum.reg.add('ramon-marketplace', 'forum/components/StoreVerifiedBadge', StoreVerifiedBadge);